import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ViewReasonModal = ({ open, handleClose, request }) => {
    if (!request) return null;

    const getValue = (value) => value || 'N/A';

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: 'hidden',
                }
            }}
        >
            {/* Header */}
            <DialogTitle sx={{ p: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 2.5,
                        py: 2,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '1rem' }}>
                        Rejection Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        size="small"
                        sx={{
                            color: 'text.secondary',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ px: 2.5, py: 4, textAlign: 'center' }}>
                    {/* Info Icon */}
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            backgroundColor: '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto',
                            mb: 3,
                        }}
                    >
                        <Icon
                            icon="solar:info-circle-bold"
                            width={40}
                            height={40}
                            style={{ color: '#ef4444' }}
                        />
                    </Box>

                    {/* Society Info */}
                    <Box
                        sx={{
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            px: 2,
                            py: 1.5,
                            border: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: 'text.primary' }}
                        >
                            {getValue(request?.societyName)}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{ color: 'text.secondary', display: 'block' }}
                        >
                            Society ID: {getValue(request?.societyId)}
                        </Typography>
                        <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    Credits Requested:
                                </Typography>
                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    {request?.credits?.toLocaleString()}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    Amount:
                                </Typography>
                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    ₹{request?.amount?.toLocaleString()}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    Request Date:
                                </Typography>
                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    {getValue(request?.requestDate)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Rejection Reason */}
                    <Box
                        sx={{
                            backgroundColor: '#fef2f2',
                            borderRadius: 2,
                            px: 2,
                            py: 1.5,
                            mt: 2,
                            border: '1px solid',
                            borderColor: '#fecaca',
                            textAlign: 'left',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#dc2626', mb: 1 }}
                        >
                            <Icon icon="mdi:alert-circle" width={16} style={{ marginRight: 6, verticalAlign: 'text-bottom' }} />
                            Rejection Reason
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: '#991b1b', lineHeight: 1.6 }}
                        >
                            {getValue(request?.rejectionReason)}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider', gap: 1.5 }}>
                <button
                    type="button"
                    className="btn btn-primary radius-8 px-20 py-10 text-sm fw-medium"
                    onClick={handleClose}
                    style={{ flex: 1 }}
                >
                    <Icon icon="solar:close-circle-outline" className="me-6" />
                    Close
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewReasonModal;
